<template>
   <!-- <div class="chan">
       产品分类
       <div class='chan-bt'>
          <a class="chan-bts" style="cursor: pointer;" v-for="(item,i) of listb" :key="i" :class="item.id==ll?'cc':''" @click="fun(item.id)">{{item.name}}</a>
       </div>
       分类详情
       <div  v-for="(item,i) of listx" :key="i" class="xiang" :id="`li${item.goods[0].gtype}`">
           <div style="font-size:18px;font-weight:900;">{{item.gtypeName}}</div>
           <div  class="xiang-kuai">
               <div style="cursor: pointer;" v-for="(items,is) of item.goods" :key="is"  @click="$router.push('/xiang/chanx/'+items.id)">
                   <div> <img height="100%" style="max-width:200px;" :src="`http://upload.lusenky.com/upload/good/${items.imgpath}`" alt=""></div>
                   <p style="text-align:center;">{{items.name}}</p>
                   <p style="text-align:center;">{{items.modName}}</p>
               </div>
           </div>
       </div>

    </div>-->
<div v-if="listx[0]!==undefined">
    <div class="title">资讯中心<span></span></div>
    <div class="xiang11">
     <!-- <div class="title1">{{listx[0].gtypeName}}</div> -->
     <div  class="xiang-kuai">
        <div class="work">
       <div style="margin-bottom:40px;" v-for="(item,i) of imgg" :key='i'>
         <img width="210px" style="margin-bottom:10px" height="157px" v-lazy="`http://upload.lusenky.com/upload/img/${item.path}`" alt="">
         <p style="text-align:center;margin-bottom:10px;">{{item.title}}</p>         
       </div>
     </div>
      </div>
    </div>
</div>
</template>
<script>

export default {
    data(){
       return{
           ll:1,
           listx:[],
           imgg:[
            {title:'古建',path:'gong1.jpg'},
            {title:'中石油液化天然气防雷',path:'gong2.jpg'},
            {title:'某部队',path:'gong3.jpg'},
            {title:'气象观测站',path:'gong4.jpg'},
            {title:'气象观测站',path:'gong5.jpg'},
            {title:'三河市新宏昌',path:'gong6.jpg'},
            {title:'国家无线电检测中心',path:'gong7.jpg'},
            {title:'北京航天试验技术研究所',path:'gong8.jpg'},
            {title:'北京环境特性研究所',path:'gong9.jpg'},
            {title:'中原油田现场',path:'gong10.jpg'}
          ],
       }
    },
    created(){
        if(this.$route.query.type){
        this.ll=this.$route.query.type
        }
        this.axios.get('goods/showOne/?typeid='+this.ll).then((res)=>{this.listx=res.data});
    },
    methods:{
      fun(id){
          this.ll=id;
          this.axios.get('goods/showOne/?typeid='+this.ll).then((res)=>{this.listx=res.data;})
      }
    }
}
</script>
<style scoped>
.work{
  /* display: flex; */
  justify-content: space-between;
  float: left;
  flex-flow: wrap;
  margin-bottom:30px;
}
.work>div{
    position: relative;
    width: 210px;
    background: #fff;
    -webkit-box-shadow: 0px 1px 10px 2px rgb(177, 174, 174);
    box-shadow: 0px 1px 10px 2px rgb(177, 174, 174);
    float: left;
    margin-left: 20px;
}
 .chan{
     font-size: 15px;
 }
  .wei{
    background: #e2e0e0;
 }
 .wei>div{
    width: 1200px;
    margin: 10px auto 20px;
    padding: 10px 0;
 }
 .chan-bt{
     width: 1250px;
     margin: 0 auto 18px;
     display: flex;
     flex-flow: wrap;
 }
 .chan-bts{
     display: block;
     width: 148px;
     height: 38px;
     margin: 10px 15px;
     background: rgba(242, 242, 242, 1);
     line-height: 38px;
     text-align: center;
     overflow: hidden;
 }
 .chan-bts:hover,.cc{
     background: red;
     color: #fff;
 }

 /** */
 .title{
         width: 148px;
        height: 45px;
        background: rgba(230,0,18,1);
        color: #fff;
        font-size: 24px;
        text-align: left;
        line-height: 45px;
        padding-left: 29px;
        font-weight: bold;
        position: relative;
 }
 .title>span{
     display: inline-block;
     width: 70px;
     height: 45px;
     background: #fff;
     right: -53px;
     border-bottom:3px solid rgba(230,0,18,1);
     position: absolute;
     -webkit-transform: skewX(45deg);
     transform: skewX(37deg);
 }
.xiang11{
    padding: 20px 15px;
    border-top: 3px solid rgba(230,0,18,1);
    background:#EDEDED;
    height: 886px;
}
.title1{
    height:28px;
    line-height: 28px;
    color: black;
    text-align: left;
    padding-left: 20px;
    border-left:3px solid rgba(230,0,18,1);
    font-size:22px;
    font-family:Microsoft YaHei;
    font-weight:bold;
}
</style>